var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.value ? '/icons/ok.svg' : '/icons/cancel.svg',"alt":_vm.value ? '✓' : '!'},on:{"click":_vm.emit}})}
var staticRenderFns = []

export { render, staticRenderFns }